import { PALETTE } from 'Theme';

const normalizeApexSyncStatus = (status) => {
  return status.replace(' ', '_').toUpperCase();
};

const MAP_COLORS_INVESTIGATION_STATUS = {
  INTERMEDIATE: { textColor: 'white', backgroundColor: PALETTE.facet.orange },
  REJECTED: { textColor: 'white', backgroundColor: PALETTE.facet.red },
  APPEALED: { textColor: 'white', backgroundColor: PALETTE.facet.accentGreen2 },
  NEW: { textColor: 'white', backgroundColor: PALETTE.facet.accentGreen2 },
  ACCEPTED: { textColor: 'white', backgroundColor: PALETTE.facet.accentGreen2 },
  default: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
  },
};
const getApexInvestigationStatusColor = key => {
  if (key in MAP_COLORS_INVESTIGATION_STATUS) {
    return MAP_COLORS_INVESTIGATION_STATUS[key];
  }
  return MAP_COLORS_INVESTIGATION_STATUS.default;
};

const USA = 'USA';

const MAP_COLORS_APEX_ACCOUNT_CREATION_STATUS = {
  ACCOUNT_SETUP: {
    iconColor: PALETTE.facet.accentBlue,
  },
  COMPLETE: {
    iconColor: PALETTE.secondary.main,
  },
  PROCESSING: {
    iconColor: PALETTE.facet.accentBlue,
  },
  ACTIVE: {
    iconColor: PALETTE.secondary.main,
  },
  BACK_OFFICE: {
    iconColor: PALETTE.facet.accentBlue,
  },
  INVESTIGATION_SUBMITTED: {
    iconColor: PALETTE.facet.accentBlue,
  },
  READY_FOR_BACK_OFFICE: {
    iconColor: PALETTE.facet.accentBlue,
  },
  PENDING: {
    iconColor: PALETTE.facet.orange,
  },
  ACTION_REQUIRED: {
    iconColor: PALETTE.facet.red,
  },
  SUSPENDED: {
    iconColor: PALETTE.facet.red,
  },
  ERROR: {
    iconColor: PALETTE.facet.red,
  },
  default: {
    iconColor: PALETTE.facet.lightGray,
  },
};

const getApexAccountCreationStatusColor = key => {
  if (key in MAP_COLORS_APEX_ACCOUNT_CREATION_STATUS) {
    return MAP_COLORS_APEX_ACCOUNT_CREATION_STATUS[key];
  }
  return MAP_COLORS_APEX_ACCOUNT_CREATION_STATUS.default;
};

const MAP_COLORS_APEX_ACCOUNT_CREATION_STATUS_INFO = {
  ACTION_REQUIRED: 'error',
  PENDING: 'warning',
  ACTIVE: 'success',
};

export const getApexAccountCreationStatusInfoColor = key => {
  return MAP_COLORS_APEX_ACCOUNT_CREATION_STATUS_INFO[key] ?? 'warning';
};

const MAP_COLORS_ACH_RELATIONSHIP_STATUS = {
  CANCELLED: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
  },
  PENDING: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
  },
  APPROVED: {
    textColor: 'white',
    backgroundColor: PALETTE.facet.accentGreen2,
  },
  REJECTED: {
    textColor: 'white',
    backgroundColor: PALETTE.facet.red,
  },
  default: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
  },
};

const getApexACHRelationshipStatusColor = key => {
  if (key in MAP_COLORS_ACH_RELATIONSHIP_STATUS) {
    return MAP_COLORS_ACH_RELATIONSHIP_STATUS[key];
  }
  return MAP_COLORS_ACH_RELATIONSHIP_STATUS.default;
};

const MAP_COLORS_ACH_RELATIONSHIP_TRANSFER_TYPE = {
  deposits: { textColor: PALETTE.facet.accentGreen2 },
  withdrawals: { textColor: PALETTE.facet.orange },
  default: { textColor: PALETTE.facet.darkGray },
};
const getApexACHRelationshipTransferTypeColor = key => {
  if (key in MAP_COLORS_ACH_RELATIONSHIP_TRANSFER_TYPE) {
    return MAP_COLORS_ACH_RELATIONSHIP_TRANSFER_TYPE[key];
  }
  return MAP_COLORS_ACH_RELATIONSHIP_TRANSFER_TYPE.default;
};

const MAP_COLORS_ACH_RELATIONSHIP_TRANSFER_STATUS = {
  RejectedValidationFailed: {
    textColor: 'white',
    backgroundColor: PALETTE.facet.red,
    iconColor: PALETTE.facet.red,
  },
  RejectedUnapproved: {
    textColor: 'white',
    backgroundColor: PALETTE.facet.red,
    iconColor: PALETTE.facet.red,
  },
  RejectedFundsNotPosted: {
    textColor: 'white',
    backgroundColor: PALETTE.facet.red,
    iconColor: PALETTE.facet.red,
  },
  FundsPosted: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
    iconColor: PALETTE.facet.accentBlue,
  },
  Completed: {
    textColor: 'white',
    backgroundColor: PALETTE.facet.accentGreen2,
    iconColor: PALETTE.facet.accentGreen2,
  },
  Complete: {
    textColor: 'white',
    backgroundColor: PALETTE.facet.accentGreen2,
    iconColor: PALETTE.facet.accentGreen2,
  },
  Returned: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
    iconColor: PALETTE.facet.darkGray,
  },
  Canceled: {
    textColor: 'white',
    backgroundColor: PALETTE.facet.red,
    iconColor: PALETTE.facet.red,
  },
  Postponed: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
    iconColor: PALETTE.facet.accentBlue,
  },
  Requested: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
    iconColor: PALETTE.facet.accentBlue,
  },
  Scheduled: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
    iconColor: PALETTE.facet.accentBlue,
  },
  'Awaiting Cash Generation': {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
    iconColor: PALETTE.facet.accentBlue,
  },
  default: {
    textColor: PALETTE.facet.darkGray,
    backgroundColor: PALETTE.facet.lightGray,
    iconColor: PALETTE.facet.darkGray,
  },
};

const getApexACHRelationshipTransferStatusColor = key => {
  if (key in MAP_COLORS_ACH_RELATIONSHIP_TRANSFER_STATUS) {
    return MAP_COLORS_ACH_RELATIONSHIP_TRANSFER_STATUS[key];
  }
  return MAP_COLORS_ACH_RELATIONSHIP_TRANSFER_STATUS.default;
};

const OPEN_AND_FUND_ACTION_ITEM_TYPE = 'open-and-fund-account';

const DIRECT_NEW_ACCOUNT_FORM_TYPE = 'direct_new_account_form';
const DIRECT_NEW_ACCOUNT_IRA_FORM_TYPE = 'direct_new_account_ira_form';
const NEW_ACCOUNT_IRA_FORM_TYPE = 'new_account_ira_form';
const TRUSTED_CONTACT_FORM_TYPE = 'trusted_contact_form';
const INTERESTED_PARTY_REQUEST_FORM_TYPE = 'interested_party_request_form';
const JOINT_RIGHTS_OF_SURVIVORSHIP_FORM_TYPE = 'joint_rights_of_survivorship_form';
const JOINT_COMMUNITY_PROPERTY_FORM_TYPE = 'joint_community_property_form';
const JOINT_TENANTS_BY_ENTIRETY_FORM_TYPE = 'joint_tenants_by_entirety_form';
const CUSTODIAL_AGREEMENT_FORM_TYPE = 'custodial_agreement_form';
const SIMPLE_IRA_PARTICIPANT_ADOPTION_AGREEMENT_FORM_TYPE = 'simple_ira_participant_adoption_agreement_form';
const ROTH_IRA_ADOPTION_AGREEMENT_FORM_TYPE = 'roth_ira_adoption_agreement_form';
const IRA_SEP_ROLLOVER_ADOPTION_AGREEMENT_FORM_TYPE = 'ira_sep_rollover_adoption_agreement_form';
const JOINT_TENANTS_IN_COMMON_FORM_TYPE = 'joint_tenants_in_common_form';
const RETIREMENT_ACCOUNT_BENEFICIARIES_FORM_TYPE = 'retirement_account_beneficiaries_form';
const TRANSFER_ON_DEATH_BENEFICIARY_DESIGNATION_FORM = 'transfer_on_death_beneficiary_designation_form';
const PENDING_APEX_ACCOUNT_CREATION = 'new-apex-account-pending-creation';

const APPEAL_PENDING_STATE = 'APPEAL_PENDING';
const APEX_ACCEPTED_STATE = 'ACCEPTED';

const APEX_NEW_STATE = 'NEW';
const APEX_SUSPENDED_STATE = 'SUSPENDED';
const APEX_COMPLETE_STATE = 'COMPLETE';
const APEX_INVESTIGATION_SUBMITTED_STATE = 'INVESTIGATION_SUBMITTED';
const APEX_PENDING_STATE = 'PENDING';
const APEX_ACCOUNT_SETUP_STATE = 'ACCOUNT_SETUP';
const APEX_BACK_OFFICE_STATE = 'BACK_OFFICE';
const APEX_READY_FOR_BACK_OFFICE_STATE = 'READY_FOR_BACK_OFFICE';
const APEX_ERROR_STATE = 'ERROR';
const APEX_APPROVED_STATE = 'APPROVED';
const APEX_ACTION_REQUIRED_STATE = 'ACTION_REQUIRED';

const DOCUMENT_TYPES = {
  DRIVERS_LICENSE: 'DRIVERS_LICENSE',
  STATE_ID_CARD: 'STATE_ID_CARD',
  PASSPORT: 'PASSPORT',
  MILITARY_ID: 'MILITARY_ID',
  SSN_CARD: 'SSN_CARD',
  SSA_LETTER: 'SSA_LETTER',
  IRS_ITIN_LETTER: 'IRS_ITIN_LETTER',
  OTHER_GOVERNMENT_ID: 'OTHER_GOVERNMENT_ID',
  CDD_DOCUMENT: 'CDD_DOCUMENT',
};

const DOCUMENT_TYPE_PROMPT = {
  DRIVERS_LICENSE: "Driver's License",
  STATE_ID_CARD: 'State ID',
  PASSPORT: 'Passport',
  MILITARY_ID: 'Military ID',
  SSN_CARD: 'SSN Card',
  SSA_LETTER: 'SSA Letter',
  IRS_ITIN_LETTER: 'IRS Letter',
  OTHER_GOVERNMENT_ID: 'W-2/1099',
  CDD_DOCUMENT: 'Utility Bill',
};

const DOCUMENT_TYPE_RELATIONSHIP = {
  DRIVERS_LICENSE: 'driversLicense',
  STATE_ID_CARD: 'stateId',
  PASSPORT: 'passport',
  MILITARY_ID: 'militaryID',
  SSN_CARD: 'socialSecurityCard',
  SSA_LETTER: 'ssaLetter',
  IRS_ITIN_LETTER: 'irsLetter',
  OTHER_GOVERNMENT_ID: 'taxDocument',
  CDD_DOCUMENT: 'utilityBill',
};

const DOCUMENT_UPLOAD_TYPES = {
  ID_CARD: 'id_card',
  TAX_DOCUMENT: 'tax_document',
  UTILITY_BILL: 'utility_bill',
};

export {
  getApexInvestigationStatusColor,
  getApexACHRelationshipStatusColor,
  getApexAccountCreationStatusColor,
  getApexACHRelationshipTransferTypeColor,
  getApexACHRelationshipTransferStatusColor,
  normalizeApexSyncStatus,
  CUSTODIAL_AGREEMENT_FORM_TYPE,
  DIRECT_NEW_ACCOUNT_FORM_TYPE,
  DIRECT_NEW_ACCOUNT_IRA_FORM_TYPE,
  INTERESTED_PARTY_REQUEST_FORM_TYPE,
  IRA_SEP_ROLLOVER_ADOPTION_AGREEMENT_FORM_TYPE,
  JOINT_COMMUNITY_PROPERTY_FORM_TYPE,
  JOINT_RIGHTS_OF_SURVIVORSHIP_FORM_TYPE,
  JOINT_TENANTS_BY_ENTIRETY_FORM_TYPE,
  JOINT_TENANTS_IN_COMMON_FORM_TYPE,
  NEW_ACCOUNT_IRA_FORM_TYPE,
  RETIREMENT_ACCOUNT_BENEFICIARIES_FORM_TYPE,
  ROTH_IRA_ADOPTION_AGREEMENT_FORM_TYPE,
  SIMPLE_IRA_PARTICIPANT_ADOPTION_AGREEMENT_FORM_TYPE,
  TRUSTED_CONTACT_FORM_TYPE,
  TRANSFER_ON_DEATH_BENEFICIARY_DESIGNATION_FORM,
  APPEAL_PENDING_STATE,
  APEX_ACCEPTED_STATE,
  DOCUMENT_TYPE_PROMPT,
  DOCUMENT_TYPE_RELATIONSHIP,
  DOCUMENT_TYPES,
  DOCUMENT_UPLOAD_TYPES,
  APEX_NEW_STATE,
  APEX_SUSPENDED_STATE,
  APEX_COMPLETE_STATE,
  APEX_INVESTIGATION_SUBMITTED_STATE,
  APEX_PENDING_STATE,
  APEX_ACCOUNT_SETUP_STATE,
  APEX_BACK_OFFICE_STATE,
  APEX_READY_FOR_BACK_OFFICE_STATE,
  APEX_ERROR_STATE,
  APEX_APPROVED_STATE,
  PENDING_APEX_ACCOUNT_CREATION,
  APEX_ACTION_REQUIRED_STATE,
  OPEN_AND_FUND_ACTION_ITEM_TYPE,
  USA,
};


export const ACCOUNT_OPENING_CARD_TITLE = 'Finish opening your accounts';
export const ACCOUNT_OPENING_CARD_SUBTITLE = 'You have accounts you need to open and fund.';
export const ONE_TIME_FREQUENCY = 'one-time';
